export const failureHash = {
    BILLING_POLICY_INCOMPATIBLE: "API__EP__BILLING__POLICY__BILLING_POLICY_INCOMPATIBLE",
    RECURRING_PAYMENT_BILLING_POLICY_LOCKED: "API__EP__BILLING__POLICY__RECURRING_PAYMENT_BILLING_POLICY_LOCKED",
};
//# sourceMappingURL=policy.static.js.map